import Modal from 'react-modal'
import { ReactComponent as Github } from '../data/Github.svg'
import { ReactComponent as Close } from '../data/Close.svg'

Modal.setAppElement('#root')

type Props = {
  isOpen: boolean
  handleClose: () => void
  darkMode: boolean
  styles: any
}

export const InfoModal = ({ isOpen, handleClose, darkMode, styles }: Props) => (
  <Modal isOpen={isOpen} onRequestClose={handleClose} style={styles} contentLabel="Game Info Modal">
    <div className={`h-full ${darkMode ? 'dark' : ''}`}>
      <button
        className="absolute top-4 right-4 rounded-full nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark p-1 w-6 h-6 sm:p-2 sm:h-8 sm:w-8 hover:nm-inset-background dark:hover:nm-inset-background-dark"
        onClick={handleClose}
      >
        <Close />
      </button>
      <div className="h-full flex flex-col items-center justify-center max-w-[390px] mx-auto pt-9 text-primary dark:text-primary-dark">
        <div className="flex-1 w-full sm:text-base text-sm">
          <h1 className="text-center sm:text-3xl text-2xl">Hvernig á að spila</h1>
          <ul className="list-disc pl-5 block sm:text-base text-sm">
            <li className="mt-6 mb-2">Þú hefur 6 tilraunir til að giska rétt orð.</li>
            <li className="mb-2">Þú getur notað nær öll íslensk orð. Eins og er ekki séríslenskir stafir eða broddstafir</li>
            <li className="mb-2">
              Eftir hvert gisk, verða stafirnir grænir, gulir eða gráir.
            </li>
          </ul>
          <div className="mb-3 mt-8 flex items-center">
            <span className="nm-inset-n-green text-gray-50 inline-flex items-center justify-center text-3x w-10 h-10 rounded-full">
              O
            </span>
            <span className="mx-2"> </span>
            <span>Réttur bókstafur á réttum stað</span>
          </div>
          <div className="mb-3">
            <span className="nm-inset-yellow-500 text-gray-50 inline-flex items-center justify-center text-3x w-10 h-10 rounded-full">
              O
            </span>
            <span className="mx-2"> </span>
            <span>Bókstafur í orðinu, rangur staður</span>
          </div>
          <span className="nm-inset-n-gray text-gray-50 inline-flex items-center justify-center text-3x w-10 h-10 rounded-full">
            O
          </span>
          <span className="mx-2"> </span>
          <span>Bókstafur ekki í orðinu</span>
        </div>

        <div className="flex justify-center sm:text-base text-sm">
          <span>Nær öll 5 bókstafa orð eru gild orð í leiknum, og mun finnast í Beygingarlýsingu íslensks nútímamáls (BÍN) á vefsíðu Stofnunar Árna Magnússonar í íslenskum fræðum.</span>
          </div>
        <div className="flex justify-center sm:text-base text-sm">
          <span>Þetta verkefni byggir á opnum kóða </span>
          <a
            className="ml-[6px] rounded-full h-5 w-5 sm:h-6 sm:w-6"
            href="https://github.com/octokatherine/word-master"
            target="_blank"
            rel="noreferrer"
          >
            <Github />
          </a>
        </div>
      </div>
    </div>
  </Modal>
)
